import { UniqueIdentifier } from '@dnd-kit/core';
import { ItemsI } from '../types';
import { findContainerId } from './findContainerId';

/**
 * GetIndex.
 */
export const getIndex = (id: UniqueIdentifier, items: ItemsI) => {
  const containerId = findContainerId(id, items);

  if (!containerId) {
    return -1;
  }

  return items[containerId].indexOf(id);
};
